/**
 * Visual chrome insets in CSS pixels.
 * The navbar overlays the workspace, so the drawing logic and pan/zoom
 * math need to know about it to keep paper sheets centred in the
 * VISIBLE area (below navbar, above status bar).
 *
 * Keep these in sync with the matching CSS variables in app.css:
 *   --h-navbar: 60px
 *   --h-status:  28px
 */
export const NAVBAR_HEIGHT = 60;
export const STATUS_HEIGHT = 28;
